export class TransactionReceipt {
  public css: string;
  public html: string;

  constructor(css?: string, html?: string) {
    this.css = css;
    this.html = html;
  }
}
